"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreditCardService = void 0;
var Base_1 = require("../Base");
var apiRoutes_1 = require("../../utils/apiRoutes");
var CreditCardService = /** @class */ (function (_super) {
    __extends(CreditCardService, _super);
    function CreditCardService(serviceConfig) {
        if (serviceConfig === void 0) { serviceConfig = {}; }
        var _this = _super.call(this, serviceConfig) || this;
        _this.baseURLForPCI = apiRoutes_1.pciOrigin;
        var baseURLForPCI = serviceConfig.baseURLForPCI;
        if (baseURLForPCI) {
            _this.baseURLForPCI = baseURLForPCI;
        }
        return _this;
    }
    CreditCardService.prototype.fetchCreditCard = function (creditCardId) {
        return this.request({
            method: 'get',
            url: apiRoutes_1.publicCreditCardUrl(creditCardId),
        }).then(function (response) { return response.creditCard; });
    };
    CreditCardService.prototype.fetchCreditCards = function (options) {
        if (options === void 0) { options = {}; }
        var _a = options.fullInfo, fullInfo = _a === void 0 ? false : _a;
        return this.request(__assign({ method: 'get', url: apiRoutes_1.publicCreditCardsUrl() }, (fullInfo
            ? {
                params: { fullInfo: fullInfo },
            }
            : {}))).then(function (response) { return response.creditCards; });
    };
    CreditCardService.prototype.tokenizeCreditCard = function (data) {
        return this.request({
            baseURL: this.baseURLForPCI,
            method: 'post',
            url: apiRoutes_1.tokenizeCardUrl(),
            data: data,
        }).then(function (response) { return response.token; });
    };
    CreditCardService.prototype.tokenizeSavedCreditCard = function (creditCardId, data) {
        return this.request({
            baseURL: this.baseURLForPCI,
            method: 'post',
            url: apiRoutes_1.tokenForSavedCard(creditCardId),
            data: data,
        }).then(function (response) { return response.token; });
    };
    CreditCardService.prototype.saveCreditCard = function (creditCard) {
        return this.request({
            baseURL: this.baseURLForPCI,
            method: 'post',
            url: apiRoutes_1.creditCardsUrl(),
            data: { creditCard: creditCard },
        }).then(function (response) { return response.creditCard; });
    };
    CreditCardService.prototype.updateCreditCard = function (data) {
        return this.request({
            baseURL: this.baseURLForPCI,
            method: 'patch',
            url: apiRoutes_1.creditCardUrl(data.creditCardId),
            data: __assign({ creditCard: data.creditCard }, (data.fieldMask
                ? {
                    fieldMask: data.fieldMask,
                }
                : {})),
        }).then(function (response) { return response.creditCard; });
    };
    CreditCardService.prototype.deleteCreditCard = function (creditCardId) {
        return this.request({
            method: 'delete',
            url: apiRoutes_1.publicCreditCardUrl(creditCardId),
        });
    };
    CreditCardService.prototype.makeCreditCardPrimary = function (creditCardId) {
        return this.request({
            method: 'post',
            url: apiRoutes_1.publicCreditCardPrimaryUrl(creditCardId),
        });
    };
    return CreditCardService;
}(Base_1.BaseService));
exports.CreditCardService = CreditCardService;
//# sourceMappingURL=index.js.map